import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as classnames from 'classnames';
import './style.sass';
export const CornerNotice = ({ title, open, warning, children, padding = true, onClose, }) => (_jsxs("div", { className: "corner-notice", style: { display: open ? 'block' : 'none' }, children: [_jsxs("div", { className: classnames('corner-notice-header', {
                'with-close': onClose != null,
                warning: warning,
            }), children: [_jsx("span", { children: title }), onClose != null && (_jsx("span", { className: "close", onClick: onClose, children: "\u00D7" }))] }), _jsx("div", { className: classnames('corner-notice-body', { 'without-padding': !padding }), children: children })] }));
export const CornerNoticesContainer = ({ children, raise_above_tabs, }) => {
    if (React.Children.count(children) === 0)
        return null;
    return (_jsx("div", { className: classnames('corner-notices-container', {
            'raise-above-tabs': raise_above_tabs,
        }), children: children }));
};
